import { create } from 'zustand';
import type { LatLon } from '@boatnav/core';

/**
 * Measure tool (spec 14A) — tap-to-measure distance/bearing, the paper-chart
 * divider replacement. Deliberately NOT persisted: a measurement is
 * ephemeral, gone the moment you toggle off or leave the screen.
 */
interface MeasureState {
  active: boolean;
  points: LatLon[];
  toggle: () => void;
  addPoint: (lat: number, lon: number) => void;
  undo: () => void;
  exit: () => void;
}

export const useMeasureStore = create<MeasureState>((set) => ({
  active: false,
  points: [],
  // Both directions start a clean slate: turning on begins a fresh
  // measurement, turning off clears the just-finished one (spec: "exiting
  // measure mode ... clears the layer").
  toggle: () => set((s) => ({ active: !s.active, points: [] })),
  addPoint: (lat, lon) =>
    set((s) => (s.active ? { points: [...s.points, { lat, lon }] } : s)),
  undo: () => set((s) => ({ points: s.points.slice(0, -1) })),
  exit: () => set({ active: false, points: [] }),
}));
